import Image from 'app/Components/Shared/Image/image';
import React, { useState, useContext } from 'react';
import OTPVerifyPhone from 'app/Components/Block/SaleBlock/OTPVerifyPhone/OTPVerifyPhone';
import { connect } from 'react-redux';
import { showAppLoader, hideAppLoader } from 'app/Components/Shared/Loader/LoaderSlice';
import { createOtp } from '../SimActivationProviders';
import SimActivationContext from 'app/Components/Page/SimActivationPage/SimActivationContext';
import { reset } from 'app/Components/Block/SaleBlock/OTPVerifyPhone/OTPVerifyPhoneSlice';
import { getRecaptchaToken } from 'app/utilities/recaptcha/recaptcha';
import EsimVerifyPhone from './EsimVerifyPhone';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit'
import icon16Checkmark from '../images/icon-16-checkmark.svg';
import { dwhPortingPhonePageButtonClick } from '../reports/dwhReports';

function SimVerifyPhone(props) {
  let esimInstructionsList =null;
  if(props.esimData?.value!=null){
   esimInstructionsList = props.esimData?.expandedValue[0]?.instructionEsimNiudFirstScreen?.value;
  }

  const [_, dispatch] = useContext(SimActivationContext);
  const [submit, setSubmit] = useState(false);
  async function onValid(valid: boolean) {
    setSubmit(false);
    if (valid) {
      const captchaToken = await getRecaptchaToken('SimVerifyPhone');
      if (!captchaToken) return;
      props.showAppLoader();
      const phoneNumber = props._otpPhone;
      const ticket = await createOtp({ phoneNumber, sendTextAsVoice: false, captchaToken });
      if (ticket) {
        props.reset();
        dispatch({ type: 'ticket', ticket, phone: phoneNumber });
      }
      props.hideAppLoader();
    }
  }

  return (
    <div className='SimVerifyPhone'>
      <h1 className='SimActivationBlock__main__title' />
      <h1 className='first-title'>נתחיל בניוד המספר שלך</h1>
      {esimInstructionsList!=null && esimInstructionsList?.length>0 && <div className='SimActivationBlock__esimInstructions'>

        <label className='second-title'>אם רכשתם eSIM</label>
        {esimInstructionsList?.map((e: any, i: number) => {
          return (<div className='div-list-style'>
            <div className='img-sign' style={{backgroundImage:icon16Checkmark.bg()}}></div>
            <li className={i!=1 ? 'inner-text' : 'inner-text-bold'} key={i}>{e}</li>
          </div>)
        })}
      </div>}

      <div className='SimVerifyPhone__input'>
        <OTPVerifyPhone
          onValid={onValid}
          onSubmit={submit}
          placeholder='מספר הטלפון לניוד'
          comment='שימו לב! לא להוציא את ה-SIM הישן מהמכשיר'
        />
      </div>
      <div className='inner-text-semi-bold'>זה כל כך פשוט!</div>
      <div className='SimVerifyPhone__items'>
        <div className='SimVerifyPhone__item'>
          <div className='SimVerifyPhone__item__icon'>
            <Image src={require('../images/sim-process-1.svg')} />
          </div>
          <div className='SimVerifyPhone__item__text'>אימות מספר הנייד לניוד</div>
        </div>
        <div className='SimVerifyPhone__item'>
          <div className='SimVerifyPhone__item__icon'>
            <Image src={require('../images/sim-process-2.svg')} />
          </div>
          <div className='SimVerifyPhone__item__text'>הקלדת המספר שנשלח אליכם</div>
        </div>
        <div className='SimVerifyPhone__item'>
          <div className='SimVerifyPhone__item__icon'>
            <Image src={require('../images/sim-process-3.svg')} />
          </div>
          <div className='SimVerifyPhone__item__text'>קבלת תאריך ושעת ניוד</div>
        </div>
        <div className='SimVerifyPhone__item'>
          <div className='SimVerifyPhone__item__icon'>
            <Image src={require('../images/sim-process-4.svg')} />
          </div>
          <div className='SimVerifyPhone__item__text'>הניוד עבר בהצלחה!</div>
        </div>
      </div>

      <BtnSubmit
        onclick={() => {
          dwhPortingPhonePageButtonClick({ subscriber: props._otpPhone ?? '', userDetails: props.userDetails });
          setSubmit(true);
        }}
        text={`זיהוי ומתחילים`}
      />
    </div>
  );
}

const mapDispatchToProps = {
  showAppLoader,
  hideAppLoader,
  reset,
};

const mapStateToProps = (state) => {
  return {
    _otpPhone: state.otpVerifyPhone.form.phone,
    userDetails: state.authentication?.loginData?.userDetails,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SimVerifyPhone);
